export const IncomeCalcErrorCode = {
  GSA_API_ERROR: 'GSA_API_ERROR',
  INVALID_CITY: 'INVALID_CITY',
  INVALID_DATE: 'INVALID_DATE',
  NO_GSA_DATA: 'NO_GSA_DATA',
  NO_STATE_DATA: 'NO_STATE_DATA',
  YEAR_OUT_OF_RANGE: 'YEAR_OUT_OF_RANGE',
} as const

type ApiErrorResponse = {
  data?: {
    message?: string
    details?: {
      code?: string
    }
  }
  message?: string
  details?: {
    code?: string
  }
}

export const getIncomeCalcErrorMessage = (error: unknown): { message: string; field?: string } => {
  const apiError = error as ApiErrorResponse
  const payload = apiError?.data ?? apiError
  const code = payload?.details?.code
  const fallbackMessage = payload?.message

  switch (code) {
    case IncomeCalcErrorCode.INVALID_DATE:
      return { field: 'start-date', message: 'Invalid start date.' }
    case IncomeCalcErrorCode.YEAR_OUT_OF_RANGE:
      return { field: 'start-date', message: 'Rates are not available for that date.' }
    case IncomeCalcErrorCode.INVALID_CITY:
      return { field: 'city', message: 'Select a valid city from the list.' }
    case IncomeCalcErrorCode.NO_STATE_DATA:
      return {
        message: 'GSA per diem rates are not available for this state in this calculator.',
      }
    case IncomeCalcErrorCode.NO_GSA_DATA:
      return { message: 'No rates found for this location and date.' }
    case IncomeCalcErrorCode.GSA_API_ERROR:
      return { message: 'Unable to fetch GSA data.' }
    default:
      return { message: fallbackMessage || 'Unable to fetch GSA data.' }
  }
}

export const isNegativeNumericValue = (value?: string): boolean => {
  if (value === undefined || value === '') {
    return false
  }
  return Number(value) < 0
}

export const isAllowedNonNegativeNumericInput = (value: string): boolean => {
  if (value === '') {
    return true
  }

  const parsed = Number(value)
  return !Number.isNaN(parsed) && parsed >= 0
}

export const blockNegativeNumberKeys = (evt: { key: string; preventDefault: () => void }) => {
  if (evt.key === '-' || evt.key === 'e' || evt.key === 'E') {
    evt.preventDefault()
  }
}
